import { defineMessages } from '@atlassian/jira-intl';

export const messages = defineMessages({
	placeholder: {
		id: 'servicedesk-insight-attribute-views.group.placeholder',
		defaultMessage: 'No groups selected',
		description: 'Message displayed when there are no groups selected for an attribute',
	},
});
